<template>
  <div id="ChangePassword">
    <el-dialog width="608px" center :visible.sync="isDialogVisible">
      <div>To help keep your account secure, we recommend updating your initial password on your first visit.</div>
      <el-form :model="passForm" :rules="rules2" ref="restForm">
          <el-form-item prop="Pass">
            <div style="font-weight: bold;">Current Password</div>
            <el-input v-model="passForm.Pass">
            </el-input>
          </el-form-item>
          <el-form-item prop="newPass">
            <div style="font-weight: bold;">New Password</div>
            <el-input v-model="passForm.newPass">
            </el-input>
          </el-form-item>
        <el-form-item prop="confirmPass">
          <div style="font-weight: bold;">Confirm your new password</div>
          <el-input v-model="passForm.confirmPass">
          </el-input>
        </el-form-item>
        <el-form-item style="display: flex;justify-content: center;">
          <el-button type="primary" @click="updatePass" style="font-size: 12px;width: 103px;">Update</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "ChangePassword",
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('login.placeholder1')));
      } else {
        const passPattern = /^[a-zA-Z]\w{5,17}$/;
        if (passPattern.test(value)) {
          this.$refs.restForm.validateField('confirmPass');
          return callback();
        } else {
          return callback(
            new Error(this.$t('login.hint'))
          );
        }
      }
    };
    let validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('mine.confirmpassword1')));
      } else if (value !== this.passForm.newPass) {
        callback(new Error(this.$t('mine.confirmpassword2')));
      } else {
        callback();
      }
    };
    return {
      passForm: {
        Pass: '',
        newPass: '',
        confirmPass: ''
      },
      rules2: {
        newPass: [{ validator: validatePass, trigger: 'blur' }],
        confirmPass: [{ validator: validateConfirmPass, trigger: 'blur' }],
      }
    };
  },
  computed: {
    isDialogVisible: {
      get() {
        return this.$store.getters.getDialogStatus;
      },
      set(value) {
        this.setDialogStatus(value);
      }
    }
  },
  methods: {
    ...mapActions(["setDialogStatus"]),
    updatePass() {
      if (this.passForm.Pass == this.$store.getters.getUser.password) {
        this.$refs['restForm'].validate((valid) => {
          if (valid) {
            this.$axios
              .post("/api/mall/member/updatePass", {
                id: this.$store.getters.getUser.id,
                password: this.passForm.newPass
              })
              .then(res => {
                if (res.data.code === 200) {
                  this.isDialogVisible = false;
                  this.passForm.newPass = ''
                  this.passForm.confirmPass = ''
                  this.notifySucceed(this.$t('mine.renew1'));
                } else {
                  this.notifyError(res.data.message);
                }
              })
              .catch(err => {
                return Promise.reject(err);
              });
          } else {
            return false;
          }
        });
      } else {
        this.$message.error('Old password error!');
        return false;
      }
    },
  }
};
</script>
<style>
.el-dialog {
  border-radius: 20px;
  padding: 30px 129px 30px;
}

.el-dialog__body {
  color: #000;
}

.el-dialog--center .el-dialog__body {
  padding: 0;
}

.el-dialog__headerbtn .el-dialog__close {
  color: #000;
  font-size: 18px;
  font-weight: bold;
}

.el-dialog__headerbtn .el-dialog__close:hover {
  color: #000;
}

.el-button--primary:focus,
.el-button--primary:hover {
  background: #000;
  border-color: #000;
  color: #FFF;
}

.el-button--primary {
  color: #FFF;
  font-size: 16px;
  background-color: #000;
  border-color: #000;
}
</style>